//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'detail-block',
  props: {
    isDIY: {
      type: Boolean,
      default: false
    },
    // 是否自定义内容
    isCategory: {
      type: Boolean
    },
    noBgColor: {
      type: Boolean
    }
  }
};